import { render, staticRenderFns } from "./estado.vue?vue&type=template&id=36a2bffd&scoped=true&"
import script from "./estado.vue?vue&type=script&lang=js&"
export * from "./estado.vue?vue&type=script&lang=js&"
import style0 from "./estado.vue?vue&type=style&index=0&id=36a2bffd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2bffd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VSimpleTable})
